import React, { useState } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { FiMenu } from 'react-icons/fi';
import { useLanguage } from 'src/hooks/Language';
import { useModal } from 'src/hooks/Modal';
import { SidebarContainer } from './styles';

const SidebarClassroom: React.FC<Record<string, any>> = React.memo(({ courseHook }) => {

    const { language } = useLanguage();
    const { sidebarContent, selectContent, backToStart, content } = courseHook;
    const [active, setActive] = useState(false);
    const { addModal, removeModal } = useModal();


    const showModal = () => {

        addModal({
            title: '', theme: 'none', key: 'sidebar', content: <SidebarContainer className='column  ' style={{ width: '100%', position: 'relative' }}><div className='full-width mobileOnly fixed fadeIn' style={{ maxHeight: '100vh', background: '#333' }}>
                <h2 onClick={() => { removeModal('sidebar'); window?.scrollTo(0, 0) }} className='fadeIn'>Fechar</h2>
                {sidebarContent?.map(sidebarModule => {
                    return <div className='full-width  column '>
                        <h2 className='fadeIn'>{sidebarModule?.title}</h2>
                        <div>
                            {sidebarModule?.content?.map(contentItem => {

                                return <nav style={{ color: content?._id === contentItem?._id ? '#333' : '#fff' }} className={`fadeIn ${content?._id === contentItem?._id ? 'activeSidebarMenu' : ''}`} onClick={() => {
                                    selectContent(contentItem?._id);

                                    removeModal('sidebar');
                                    window?.scrollTo(0, 0);
                                }}>{contentItem?.[`title_${language}`] ? contentItem?.[`title_${language}`] : contentItem?.title}</nav>


                            })}
                        </div>


                    </div>

                })}

            </div></SidebarContainer>
        })

    }



    return <SidebarContainer className='column  ' style={{ width: '100%', }}>
        <nav className='row   fadeIn' style={{ width: '100%', margin: ' 10px', justifyContent: 'space-between' }}>
            <h2 className='row gap-xs' style={{ color: '#fff', cursor: 'pointer', padding: '5px 10px', background: 'rgba(0,0,0,0.8)', borderRadius: '10px', }} onClick={() => { backToStart() }}><FaChevronLeft style={{ fontSize: '18px' }} /> Voltar</h2>
            <FiMenu onClick={() => showModal()} className='mobileOnly' style={{ fontSize: '32px', color: '#fff', cursor: 'pointer' }} />

        </nav>
        {sidebarContent?.map(sidebarModule => {

            return <div className='full-width  column computerOnly'>
                <h2 className='fadeIn'>{sidebarModule?.title}</h2>
                <div>
                    {sidebarModule?.content?.map(contentItem => {

                        return <nav className={`fadeIn ${content?._id === contentItem?._id ? 'activeSidebarMenu' : ''}`} onClick={() => {
                            selectContent(contentItem?._id)
                        }}>{contentItem?.[`title_${language}`] ? contentItem?.[`title_${language}`] : contentItem?.title}</nav>


                    })}
                </div>

            </div>


        })}



    </SidebarContainer>



});

export default SidebarClassroom;